import NiceModal from '@ebay/nice-modal-react';

import { Suspense, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Button from 'components/field/Button';
import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Tabs from 'components/global/Tabs';

import ImportDataModal from 'modals/ImportDataModal';

import { importActions } from 'pages/Settings/ImportExport/ImportLog/ImportLogList';

import PATHS, { mergePaths } from 'utils/paths';

import { faDownload, faSync } from '@fortawesome/pro-regular-svg-icons';

import GenerateCODReceivableModal from './GenerateCODReceivableModal';

/**
 * @author @muhammedburakak
 */

const CODReceivables = () => {
	const { pathname } = useLocation();
	const tabs = useMemo(
		() => [
			{
				label: 'newReceivableReports',
				path: mergePaths(PATHS.COD_RECEIVABLES, PATHS.NEW_RECEIVABLE_REPORTS)
			},
			{
				label: 'noConflict',
				path: mergePaths(PATHS.COD_RECEIVABLES, PATHS.NO_CONFLICT)
			},
			{
				label: 'receivedOTOBankFromDC',
				path: mergePaths(PATHS.COD_RECEIVABLES, PATHS.RECEIVED_OTO_BANK_FROM_DC)
			},
			{
				label: 'waitingReconciliationOrders',
				path: mergePaths(PATHS.COD_RECEIVABLES, PATHS.WAITING_RECONCILATION_ORDERS)
			},
			{
				label: 'reconciledOrders',
				path: mergePaths(PATHS.COD_RECEIVABLES, PATHS.RECONCILED_ORDERS)
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/logs-icon.json.gz"
				title="CODReceivables">
				{pathname === mergePaths(PATHS.COD_RECEIVABLES, PATHS.NEW_RECEIVABLE_REPORTS) && (
					<Button
						icon={faSync}
						label="generateCODReceivable"
						onClick={() => NiceModal.show(GenerateCODReceivableModal)}
						variant="blackOutline"
					/>
				)}
				{pathname === mergePaths(PATHS.COD_RECEIVABLES, PATHS.NEW_RECEIVABLE_REPORTS) && (
					<Button
						icon={faDownload}
						variant="borderless"
						label="importData"
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/importData-icon.json.gz"
						onClick={() => NiceModal.show(ImportDataModal, importActions.receivableReportsImport)}
						className="mobile-hidden importDataButton"
					/>
				)}
			</PageHeader>

			<Tabs data={tabs} checkURL />
			<Suspense fallback={<Loading />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default CODReceivables;
